import React from "react";
import { connect } from "react-redux";
import api from "../../../../../api";
import "../../../../Grid/grid.css";
import { Segment, Table, Message, Dropdown } from "semantic-ui-react";
import { Form, Checkbox } from "formsy-semantic-ui-react";
import { DatatableTable } from "../AiPhoneCallNotificationList/DatatableTable";
import { DatatableFilter } from "../AiPhoneCallNotificationList/DatatableFilter";
import DialogBoxDetail from "../AiPhoneCallNotificationList/DialogBoxDetail";
import { DatatableRow } from "./DatatableRow";
import { selectIsPLGAccount } from "../../../../../store/userSelectors";
import validationRule from "../../../../../validation";

validationRule.isRequired();
validationRule.usPhoneLength();

const tableHeader = [
  { title: "Actions",           width: "1", sort: "" },
  { title: "Notification Type", width: "2", sort: "" },
  { title: "Name",              width: "2", sort: "" },
  { title: "Email/Phone",        width: "3", sort: "" },
  { title: "Notify via",        width: "2", sort: "" },
  { title: "Unique Identifier", width: "2", sort: "" },
];

const queryParams = ["_limit", "_order", "_sort", "q", "_page"];

class DatatableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lists: [],
      _sort: "id",
      _page: 1,
      _order: "desc",
      _limit: 10,
      q: "",
      totalCount: 0,
      loading: false,
      modalstatus: false,
      modaltitle: null,
      modalbuttonmsg: {},
      modalType: null,
      modalmessage: null,
      modaldata: {},
      modalFormLoader: false,
      modalFooter: true,
      notifyvia: { email: true, phonecall: false, text: false },
      notifyviaError: false,
      messageDisplay: "none",
      color: "green",
      resMessage: "",
      buttonDisable: false,
      // Workspace / parsed-field / values — mirrors outbound voice pattern
      outboundWorkspaces: [],
      outboundSelectedWorkspaces: [],
      outboundSelectedParsedFields: {},
      outboundSelectedValues: {},
    };
  }

  componentDidMount() {
    this.loadData({});
  }

  static directionConverter(order) {
    if (order === "asc") return "ascending";
    if (order === "desc") return "descending";
    return null;
  }

  handleSort = (clickedColumn) => {
    const { _sort, _order } = this.state;
    const newOrder = _sort !== clickedColumn ? "asc" : _order === "asc" ? "desc" : "asc";
    this.loadData({ _sort: clickedColumn, _page: 1, _order: newOrder });
  };

  onChangeLimit = (event, data) => {
    if (data.value !== this.state._limit) this.loadData({ _limit: data.value, _page: 1 });
  };

  onSubmitFilter = (filter) => {
    if (filter !== this.state.q) this.loadData({ q: filter, _page: 1 });
  };

  onChangePage = (event, data) => {
    const { activePage } = data;
    if (activePage !== this.state._page) this.loadData({ _page: activePage });
  };

  modalbuttofun = (data) => {
    if (data.modalType === "Delete") this.onDeleteAction();
  };

  // ── Workspace option list ──────────────────────────────────────────────────

  outboundWorkspaceOptionList = () =>
    (this.state.outboundWorkspaces || []).map((ws) => ({
      key:   ws.workspace_id,
      text:  ws.workspace_name,
      value: ws.workspace_id,
    }));

  // ── Workspace / parsed-field / values handlers ── mirror voice pattern ────

  handleOutboundWorkspaceSelection = (e, { value }) => {
    this.setState(
      { outboundSelectedWorkspaces: value, buttonDisable: false },
      () => this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  getOutboundParsedFieldsForWorkspace = (workspaceId) => {
    const ws = (this.state.outboundWorkspaces || []).find(
      (w) => w.workspace_id === workspaceId
    );
    return ws?.parsed_fields || [];
  };

  handleOutboundParsedFieldSelection = (workspaceId, fieldKeys) => {
    this.setState(
      (prev) => ({
        outboundSelectedParsedFields: {
          ...prev.outboundSelectedParsedFields,
          [workspaceId]: fieldKeys,
        },
        buttonDisable: false,
      }),
      () => this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  handleOutboundFieldValueSelection = (workspaceId, fieldKey, values) => {
    this.setState(
      (prev) => ({
        outboundSelectedValues: {
          ...prev.outboundSelectedValues,
          [workspaceId]: {
            ...(prev.outboundSelectedValues[workspaceId] || {}),
            [fieldKey]: values,
          },
        },
        buttonDisable: false,
      }),
      () => this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  // Convert UI state → API outbound_sms_rules format (mirrors voice logic)
  convertOutboundRulesToApiFormat = () =>
    this.state.outboundSelectedWorkspaces.map((workspaceId) => {
      const selectedFields = this.state.outboundSelectedParsedFields[workspaceId] || [];
      const selectedValues = this.state.outboundSelectedValues[workspaceId] || {};
      const actualFields   = selectedFields.filter((f) => f !== "anyparsefield");

      const includeAnyBranch = selectedFields.includes("anyparsefield");
      const voiceBranch = includeAnyBranch
        ? ["anybranch", ...actualFields].join(",")
        : actualFields.join(",");

      const keyIndices = actualFields.map((k, i) => ({ key: k, index: i }));

      const branchValues = actualFields
        .filter((k) => selectedValues[k]?.length)
        .map((k, i) => ({ key: k, values: selectedValues[k], index: i }));

      return {
        workspace_id:  workspaceId,
        voice_branch:  voiceBranch,
        key_indices:   keyIndices,
        branch_values: branchValues,
        values_indices: branchValues,
      };
    });

  // Parse saved outbound_rules JSON → simplified state (mirrors voice logic)
  convertOutboundRulesToSimplifiedFormat = (outboundRules) => {
    const outboundSelectedWorkspaces    = [];
    const outboundSelectedParsedFields  = {};
    const outboundSelectedValues        = {};

    outboundRules.forEach((rule) => {
      const workspaceId =
        typeof rule.workspace_id === "string"
          ? parseInt(rule.workspace_id)
          : rule.workspace_id;
      if (!workspaceId) return;

      outboundSelectedWorkspaces.push(workspaceId);

      // Extract parsed-field selection from voice_branch
      let selectedFields = [];
      if (rule.voice_branch) {
        const branches     = rule.voice_branch.split(",").map((b) => b.trim()).filter(Boolean);
        const hasAnyBranch = branches.includes("anybranch");
        const specific     = branches.filter((b) => b !== "anybranch");
        selectedFields     = hasAnyBranch ? ["anyparsefield", ...specific] : specific;
      }
      if (!selectedFields.length) selectedFields = ["anyparsefield"];
      outboundSelectedParsedFields[workspaceId] = selectedFields;

      // Extract values
      const fieldValues = {};
      if (Array.isArray(rule.branch_values)) {
        rule.branch_values.forEach((bv) => {
          if (bv.key && bv.values) fieldValues[bv.key] = bv.values;
        });
      }
      outboundSelectedValues[workspaceId] = fieldValues;
    });

    return { outboundSelectedWorkspaces, outboundSelectedParsedFields, outboundSelectedValues };
  };

  // ── Edit / Delete ──────────────────────────────────────────────────────────

  editMember = async (id) => {
    this.setState({ loading: true });

    try {
      const recordIndex = this.state.lists.findIndex((l) => l.id === id);
      if (recordIndex === -1) { this.setState({ loading: false }); return; }

      const raw = { ...this.state.lists[recordIndex] };

      // Normalise notify_via to array
      if (typeof raw.notify_via === "string") {
        raw.notify_via = raw.notify_via ? raw.notify_via.split(",") : [];
      }
      if (!Array.isArray(raw.notify_via)) raw.notify_via = [];
      raw.notify_via = raw.notify_via.map((v) => (v === "phone" ? "phonecall" : v));

      const notifyvia = {
        email:     raw.notify_via.includes("email"),
        phonecall: raw.notify_via.includes("phonecall"),
        text:      raw.notify_via.includes("text"),
      };

      // Fetch SMS workspaces with parsed fields
      const wsRes = await api.manageUser.getOutboundSmsWorkspacesWithFields();
      const outboundWorkspaces =
        wsRes?.status && Array.isArray(wsRes.data) ? wsRes.data : [];

      // Parse saved outbound_rules
      let simplified = {
        outboundSelectedWorkspaces:   [],
        outboundSelectedParsedFields: {},
        outboundSelectedValues:       {},
      };
      if (raw.outbound_rules) {
        try {
          const rules =
            typeof raw.outbound_rules === "string"
              ? JSON.parse(raw.outbound_rules)
              : raw.outbound_rules;
          if (Array.isArray(rules) && rules.length) {
            simplified = this.convertOutboundRulesToSimplifiedFormat(rules);
          }
        } catch { /* malformed JSON — start fresh */ }
      }

      this.setState(
        {
          modaldata:       { ...raw, phone: raw.phone || raw.phone_number || "" },
          modalbuttonmsg:  { submit: "Submit", cancel: "Close" },
          modalstatus:     true,
          modaltitle:      "Edit SMS notification member",
          modalType:       "",
          modalFooter:     false,
          notifyvia,
          outboundWorkspaces,
          ...simplified,
          notifyviaError:  false,
          messageDisplay:  "none",
          buttonDisable:   false,
          loading:         false,
        },
        () => this.setState({ modalmessage: this.memberEditBody() })
      );
    } catch (err) {
      console.error("editMember error:", err);
      this.setState({ loading: false });
    }
  };

  deleteMember = (id) => {
    const recordIndex = this.state.lists.findIndex((l) => l.id === id);
    this.setState({
      modalstatus:    true,
      modaltitle:     "Confirm your action",
      modalmessage:   "Are you sure you want to delete?",
      modalbuttonmsg: { submit: "Yes", cancel: "No" },
      modalType:      "Delete",
      modaldata:      this.state.lists[recordIndex],
    });
  };

  modalClose = () => {
    this.setState({
      modalstatus:               false,
      modaltitle:                "",
      modalmessage:              "",
      modalbuttonmsg:            {},
      modalType:                 "",
      modaldata:                 {},
      modalFooter:               true,
      notifyviaError:            false,
      messageDisplay:            "none",
      outboundWorkspaces:        [],
      outboundSelectedWorkspaces:   [],
      outboundSelectedParsedFields: {},
      outboundSelectedValues:       {},
    });
  };

  // ── Submit update ──────────────────────────────────────────────────────────

  onValidSubmitMember = () => {
    if (!this.state.modaldata.notify_via || !this.state.modaldata.notify_via.length) {
      this.setState({ notifyviaError: true }, () =>
        this.setState({ modalmessage: this.memberEditBody() })
      );
      return;
    }

    this.setState({ loading: true, buttonDisable: true }, () =>
      this.setState({ modalmessage: this.memberEditBody() })
    );

    const outboundSmsRules = this.convertOutboundRulesToApiFormat();

    const payload = {
      id:                       this.state.modaldata.id,
      name:                     this.state.modaldata.name,
      email:                    this.state.modaldata.email,
      phone:                    this.state.modaldata.phone || "",
      isd_code:                 this.state.modaldata.country_code || this.state.modaldata.isd_code || "",
      notification_type:        this.state.modaldata.notification_type || 1,
      notify_via:               this.state.modaldata.notify_via.join(","),
      outbound_sms_rules:       JSON.stringify(outboundSmsRules),
      user_notification_values: this.state.modaldata.user_notification_values || "",
    };

    api.manageUser
      .updateOutboundSmsNotificationMember(payload)
      .then((res) => {
        const data       = res.data || res;
        const color      = data.status ? "green" : "red";
        const resMessage = data.message || (data.status ? "Member updated successfully." : "Failed to update member.");

        this.setState(
          { loading: false, buttonDisable: false, messageDisplay: "block", color, resMessage },
          () => this.setState({ modalmessage: this.memberEditBody() })
        );

        setTimeout(() => {
          this.setState({ messageDisplay: "none" }, () =>
            this.setState({ modalmessage: this.memberEditBody() })
          );
          if (data.status) {
            this.loadData({});
            this.modalClose();
          }
        }, 2000);
      })
      .catch((err) => {
        console.error("updateOutboundSmsNotificationMember error:", err);
        this.setState(
          { loading: false, buttonDisable: false, messageDisplay: "block", color: "red", resMessage: "An error occurred. Please try again." },
          () => this.setState({ modalmessage: this.memberEditBody() })
        );
        setTimeout(() => {
          this.setState({ messageDisplay: "none" }, () =>
            this.setState({ modalmessage: this.memberEditBody() })
          );
        }, 3000);
      });
  };

  onDeleteAction = () => {
    this.setState({ modalFormLoader: true });
    api.manageUser
      .deleteOutboundSmsNotificationMember({ id: this.state.modaldata.id })
      .then((res) => {
        this.setState({ modalFormLoader: false });
        const data = res.data || res;
        if (data.status) {
          const deletedId  = this.state.modaldata.id;
          const newLists   = this.state.lists.filter((l) => l.id !== deletedId);
          this.setState({
            lists: newLists, modalstatus: false, modaltitle: "",
            modalmessage: "", modalbuttonmsg: {}, modalType: "", modaldata: {},
          });
          this.loadData({});
        }
      })
      .catch((err) => {
        console.error("deleteOutboundSmsNotificationMember error:", err);
        this.setState({ modalFormLoader: false, modalstatus: false });
      });
  };

  // ── Form helpers ───────────────────────────────────────────────────────────

  changeNotifyVia = (fieldname) => {
    const memberData = { ...this.state.modaldata };
    let notifyData   = [...(memberData.notify_via || [])];
    if (!notifyData.includes(fieldname)) {
      notifyData.push(fieldname);
    } else {
      notifyData = notifyData.filter((v) => v !== fieldname);
    }
    memberData.notify_via = notifyData;
    const notifyvia = { ...this.state.notifyvia, [fieldname]: !this.state.notifyvia[fieldname] };
    this.setState(
      { modaldata: memberData, notifyvia, notifyviaError: false },
      () => this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  onchangeenable = (e) => {
    const memberData = { ...this.state.modaldata, [e.target.name]: e.target.value };
    this.setState({ modaldata: memberData }, () =>
      this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  phoneFormat = (p) => {
    p = p.replace(/[^\d]*/gi, "");
    if (p.length <= 3) return p;
    if (p.length < 7) return `(${p.substring(0, 3)})${p.substring(3)}`;
    const f = `(${p.substring(0, 3)})${p.substring(3, 6)}-${p.substring(6)}`;
    return f.substring(0, 13);
  };

  handlePhoneChange = (e) => {
    const p = this.phoneFormat(e.target.value);
    const memberData = { ...this.state.modaldata, phone: p };
    setTimeout(() => {
      const el = document.getElementById("smsNotifPhoneInput");
      if (el) el.value = p;
    }, 100);
    this.setState({ modaldata: memberData });
  };

  handleChangeISD = (e) => {
    const memberData = { ...this.state.modaldata, country_code: e.target.value };
    this.setState({ modaldata: memberData }, () =>
      this.setState({ modalmessage: this.memberEditBody() })
    );
  };

  renderDropDownDefault = (arr = []) =>
    arr.map((o, i) => (
      <option key={i} value={o.country_code}>{o.country_name}</option>
    ));

  renderDropDownRemaining = (arr = []) =>
    arr.map((o, i) => (
      <option key={i} value={o.country_code}>{o.country_name}</option>
    ));

  // ── Edit modal body ────────────────────────────────────────────────────────

  memberEditBody = () => {
    const errorLabel = <div className="red" />;

    return (
      <div className="col-md-12">
        <Message color={this.state.color} style={{ display: this.state.messageDisplay }}>
          {this.state.resMessage}
        </Message>

        <Form
          noValidate
          autoComplete="off"
          id="outboundSmsNotifEditForm"
          onValidSubmit={this.onValidSubmitMember}
        >
          {/* Full Name */}
          <div className="form-group">
            <label style={{ marginBottom: 0 }}>Full Name</label>
            <Form.Input
              type="text"
              name="name"
              validations="isRequired"
              validationErrors={{ isRequired: "This field is required." }}
              onChange={this.onchangeenable}
              errorLabel={errorLabel}
              defaultValue={this.state.modaldata.name}
            />
          </div>

          {/* Email */}
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label style={{ marginBottom: 0 }}>Email Address</label>
            {this.state.notifyvia.email ? (
              <Form.Input
                type="email" name="email"
                validations="isEmail,isRequired"
                validationErrors={{ isEmail: "Please enter a valid email address.", isRequired: "This field is required." }}
                errorLabel={errorLabel}
                onChange={this.onchangeenable}
                defaultValue={this.state.modaldata.email}
              />
            ) : (
              <Form.Input
                type="email" name="email"
                errorLabel={errorLabel}
                onChange={this.onchangeenable}
                defaultValue={this.state.modaldata.email}
              />
            )}
          </div>

          {/* Phone — hidden for PLG */}
          {!this.props.isPLG && (
            <div className="form-group" style={{ marginBottom: 10 }}>
              <label>Phone Number</label>
              <div className="d-flex">
                <select
                  className="form-control"
                  name="country_code"
                  onChange={this.handleChangeISD}
                  style={{ maxWidth: 166, marginRight: "1rem" }}
                  defaultValue={this.state.modaldata.country_code || this.state.modaldata.isd_code || '+1'}
                >
                  {this.renderDropDownDefault(this.props.ISDrenderOption1)}
                  <optgroup label="Other countries">
                    {this.renderDropDownRemaining(this.props.ISDrenderOption2)}
                  </optgroup>
                </select>

                {(this.state.notifyvia.text || this.state.notifyvia.phonecall) ? (
                  <Form.Input
                    fluid autoComplete="off" name="phone" maxLength="13"
                    onChange={this.handlePhoneChange} placeholder="Phone Number"
                    validations="isRequired,usPhoneLength"
                    validationErrors={{ isRequired: "This field is required.", usPhoneLength: "Phone number must be at least 10 numbers." }}
                    id="smsNotifPhoneInput" className="w-100"
                    errorLabel={errorLabel}
                    defaultValue={this.state.modaldata.phone || this.state.modaldata.phone_number}
                  />
                ) : (
                  <Form.Input
                    fluid autoComplete="off" name="phone" maxLength="13"
                    onChange={this.handlePhoneChange} placeholder="Phone Number"
                    id="smsNotifPhoneInput" className="w-100"
                    errorLabel={errorLabel}
                    defaultValue={this.state.modaldata.phone || this.state.modaldata.phone_number}
                  />
                )}
              </div>
            </div>
          )}

          {/* Notification type + Notify via */}
          <div className="row form-group" style={{ marginBottom: 10 }}>
            <div className="col-md-6">
              <div className="form-group">
                <label>Notification Type</label>
                <select className="form-control" name="notification_type" onChange={this.onchangeenable} defaultValue={this.state.modaldata.notification_type}>
                  <option value="1">All notifications</option>
                  <option value="2">Schedule based</option>
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <label>Notify via</label>
              <div style={{ display: "flex", columnGap: 10 }}>
                <Checkbox name="notifyvia" label={{ children: "Email" }} onChange={() => this.changeNotifyVia("email")} defaultChecked={this.state.modaldata?.notify_via?.includes("email")} />
                {!this.props.isPLG && <Checkbox name="notifyvia" label={{ children: "Text" }} onChange={() => this.changeNotifyVia("text")} defaultChecked={this.state.modaldata?.notify_via?.includes("text")} />}
                {!this.props.isPLG && <Checkbox name="notifyvia" label={{ children: "Phone Call" }} onChange={() => this.changeNotifyVia("phonecall")} defaultChecked={this.state.modaldata?.notify_via?.includes("phonecall")} />}
              </div>
              {this.state.notifyviaError && <div className="red">This field is required.</div>}
            </div>
          </div>

          {/* Workspace → Parsed fields → Values  (mirrors outbound voice pattern) */}
          <div className="form-group mt-2">
            <div className="row">
              <div className="form-group col-md-6 mt-2">
                <label style={{ fontSize: "14px" }}>Select Outbound SMS Workspaces</label>
                <Dropdown
                  placeholder="Select Workspaces"
                  fluid multiple search selection
                  options={this.outboundWorkspaceOptionList()}
                  value={this.state.outboundSelectedWorkspaces}
                  onChange={this.handleOutboundWorkspaceSelection}
                />
              </div>
            </div>

            {/* Per-workspace parsed fields + values */}
            {this.state.outboundSelectedWorkspaces.map((workspaceId) => {
              const workspace    = (this.state.outboundWorkspaces || []).find((ws) => ws.workspace_id === workspaceId);
              const parsedFields = this.getOutboundParsedFieldsForWorkspace(workspaceId);

              const parsedFieldOptions = [
                { key: "anyparsefield", text: "Any Parse Field", value: "anyparsefield" },
                ...(parsedFields || []).map((f) => ({ key: f.key, text: f.key, value: f.key })),
              ];

              return (
                <React.Fragment key={workspaceId}>
                  <div className="row">
                    <div className="form-group col-md-6 mt-2">
                      <label>
                        Parsed Fields for{" "}
                        <span style={{ color: "#2185d0" }}>{workspace?.workspace_name}</span>
                      </label>
                      <Dropdown
                        fluid multiple search selection
                        placeholder="Select Parsed Data"
                        options={parsedFieldOptions}
                        value={this.state.outboundSelectedParsedFields[workspaceId] || ["anyparsefield"]}
                        onChange={(e, { value }) => this.handleOutboundParsedFieldSelection(workspaceId, value)}
                      />
                    </div>

                    {/* Value dropdowns per selected parsed field */}
                    {(this.state.outboundSelectedParsedFields[workspaceId] || []).map((fieldKey) => {
                      if (fieldKey === "anyparsefield") return null;
                      const field = (parsedFields || []).find((f) => f.key === fieldKey);
                      if (!field?.values?.length) return null;

                      return (
                        <div key={fieldKey} className="form-group col-md-6 mt-2">
                          <label>
                            Values for <span style={{ color: "#2185d0" }}>{fieldKey}</span>
                          </label>
                          <Dropdown
                            fluid multiple search selection
                            placeholder={`Select ${fieldKey}`}
                            options={field.values.map((v) => ({ key: v, text: v, value: v }))}
                            value={this.state.outboundSelectedValues[workspaceId]?.[fieldKey] || []}
                            onChange={(e, { value }) =>
                              this.handleOutboundFieldValueSelection(workspaceId, fieldKey, value)
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              );
            })}
          </div>

          {/* Unique Identifier */}
          <div className="form-group">
            <label style={{ marginBottom: 0 }}>Include Unique Identifier</label>
            <input
              type="text" className="form-control" name="user_notification_values"
              onChange={this.onchangeenable}
              defaultValue={this.state.modaldata.user_notification_values}
            />
            <small>
              This value will be passed in a webhook payload if the user is notified — webhook field will be "user_notification_values"
            </small>
          </div>

          {/* Action buttons */}
          <div className="form-group" style={{ display: "flex", marginTop: 10, columnGap: 10, justifyContent: "right" }}>
            <button
              type="button" onClick={this.modalClose}
              className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
              data-dismiss="modal"
            >
              <span>Close</span>
            </button>
            <button
              disabled={this.state.buttonDisable} type="submit"
              className="btn linear-gradient yr-submitbtn btn-sm"
            >
              Submit
            </button>
          </div>
        </Form>
      </div>
    );
  };

  // ── Data loading ───────────────────────────────────────────────────────────

  loadData = (params = {}) => {
    const newState = Object.assign({}, this.state, params, { loading: false });
    queryParams.forEach((el) => {
      if (!(el in params)) params[el] = newState[el];
    });

    this.setState(newState, () => {
      this.setState({ loading: true });

      const payload = { user_id: this.props.sessionUser?.user_id };

      api.manageUser
        .getOutboundSmsNotificationList(payload)
        .then((res) => {
          const data  = res.data || res;
          const list  = Array.isArray(data?.data) ? data.data : [];

          // Client-side search
          const q        = (params.q || "").toLowerCase();
          const filtered = q
            ? list.filter(
                (item) =>
                  (item.name  || "").toLowerCase().includes(q) ||
                  (item.email || "").toLowerCase().includes(q)
              )
            : list;

          // Client-side pagination
          const page  = params._page  || this.state._page;
          const limit = params._limit || this.state._limit;
          const paged = filtered.slice((page - 1) * limit, page * limit);

          let datatableRows;
          if (paged.length > 0) {
            datatableRows = paged.map((item, i) => (
              <DatatableRow
                key={i}
                list={item}
                editMember={this.editMember}
                deleteMember={this.deleteMember}
                isPLG={this.props.isPLG}
              />
            ));
          } else {
            datatableRows = (
              <Table.Row>
                <Table.Cell colSpan={6} textAlign="center">No record found.</Table.Cell>
              </Table.Row>
            );
          }

          this.setState({ datatableRows, lists: list, totalCount: filtered.length, loading: false });
        })
        .catch((err) => {
          console.error("getOutboundSmsNotificationList error:", err);
          this.setState({ loading: false });
        });
    });
  };

  // ── Render ─────────────────────────────────────────────────────────────────

  render() {
    return (
      <Segment>
        {this.state.loading && <div className="ui loading form"></div>}
        <DatatableFilter
          filter={this.state.q}
          totalCount={this.state.totalCount}
          onSubmitFilter={this.onSubmitFilter}
          loading={this.state.loading}
        />
        <DialogBoxDetail
          obj={this.state}
          show={this.state.modalstatus}
          title={this.state.modaltitle}
          message={this.state.modalmessage}
          modalType={this.state.modalType}
          modalClose={this.modalClose}
          buttonmsg={this.state.modalbuttonmsg}
          modalbuttofun={this.modalbuttofun}
          loading={this.state.loading}
          currentChecked={[]}
          currentExpanded={[]}
          setCurrentCheck={() => {}}
          setCurrentExpand={() => {}}
          modalFooter={this.state.modalFooter}
        />
        <DatatableTable
          lists={this.state.lists}
          datatableHeader={tableHeader}
          datatableRows={this.state.datatableRows}
          totalCount={this.state.totalCount}
          totalPages={Math.ceil(this.state.totalCount / this.state._limit) || 1}
          currentPage={this.state._page}
          onChangePage={this.onChangePage}
          column={this.state._sort}
          direction={DatatableList.directionConverter(this.state._order)}
          handleSort={this.handleSort}
          onChangeLimit={this.onChangeLimit}
          limit={this.state._limit.toString()}
        />
      </Segment>
    );
  }
}

const mapStateToProps = (state) => ({
  isPLG: selectIsPLGAccount(state),
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(DatatableList);
